import _ from 'lodash';

const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
const RI_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*().?;:])/;

export function checkEmailValidity(email) {
    return EMAIL_REGEX.test(email);
}

export function isEmpty(value) {
    return _.isNil(value) || _.isEmpty(value);
}

export function checkRIPasswordValidity(password) {
    if (!isEmpty(password) && (password.trim()).length >= 8)  {
        return RI_PASSWORD_REGEX.test(password);
    } else {
        return false;
    }
}
